module.exports = __webpack_public_path__ + "img/logo-wabi.589a41b.png";